<mat-icon
  mat-list-icon
  *ngIf="name"
  [svgIcon]="name"
  class="flex aic jcc"
  [ngStyle]="{
    color: color,
    width: size + 'px',
    height: size + 'px',
  }"
></mat-icon>
